import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import MenuHeader from "./menuHeader";
import { Collapse } from "reactstrap";
import "./header.css";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import * as UserProvider from "../../providers/userProvider";
import * as CategoryProvider from "../../providers/categoryProvider";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarState: "close",
      collapseSidebar: false
    };
  }

  componentDidMount() {
    this.props.doCheckLogin();
    this.props.doGetGroups();
    this.props.doGetCategories();
  }

  toggle = () => {
    this.setState(prevState => ({
      collapseSidebar: !prevState.collapseSidebar
    }));
  };

  handleSidebar = () => {
    this.setState({ collapseSidebar: false });
    switch (this.state.sidebarState) {
      case "close":
        return this.setState({ sidebarState: "open" });
      case "open":
        return this.setState({ sidebarState: "close" });
    }
  };

  handleLogout = () => {
    this.props.doLogout(this.props.userId);
    this.handleSidebar();
  };

  render() {
    return (
      <div id="header">
        <header>
          <div className="logo-container d-flex flex-row align-items-center">
            <Link to="/" className="imgLogo d-flex flex-row align-items-center">
              <img src={require("../../imagens/consultazap_logo.png")} />
              <h1 id="nomeLogo">Consulta ZAP</h1>
            </Link>
            {/* <div className="hide-if-mobile">
              <img
                className="img-social-media"
                alt="social-media"
                src="https://icons-for-free.com/iconfiles/png/512/instagram+new+design+liner+round+social+media+icon-1320184016593501800.png"
              />
              <img
                className="img-social-media"
                alt="social-media"
                src="https://icons-for-free.com/iconfiles/png/512/instagram+new+design+liner+round+social+media+icon-1320184016593501800.png"
              />
              <img
                className="img-social-media"
                alt="social-media"
                src="https://icons-for-free.com/iconfiles/png/512/instagram+new+design+liner+round+social+media+icon-1320184016593501800.png"
              />
            </div> */}
          </div>
          <MenuHeader categories={this.props.categories} />
          <button
            className="navbar-toggler show-if-mobile"
            onClick={this.handleSidebar}
          ></button>
        </header>
        <div id="sidebar" className={`${this.state.sidebarState}`}>
          <Link className="nav-link" to="/" onClick={this.handleSidebar}>
            <h4 className="item-text">Inicio</h4>
          </Link>
          <Link
            className="nav-link"
            to="/como-funciona"
            onClick={this.handleSidebar}
          >
            <h4 className="item-text">Como funciona</h4>
          </Link>
          <button
            className="nav-link"
            type="button"
            data-toggle="collapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={this.toggle}
          >
            <h4 className="item-text">
              Especialidades
              <FontAwesomeIcon
                icon={faChevronDown}
                transform="shrink-4 down-2 right-2"
                color="white"
              />
            </h4>
          </button>
          <Collapse
            isOpen={this.state.collapseSidebar}
            className="sidebar-collapse"
          >
            {this.props.categories.map(item => (
              <Link
                key={item._id}
                className="nav-link"
                to={`/categoria/${item._id}/profissionais`}
                onClick={this.handleSidebar}
              >
                <h5 className="item-text sidebar-collapse-option ml-1">
                  {item.name}
                </h5>
              </Link>
            ))}
            {/* <Link className='nav-link' to="/profile" onClick={this.handleSidebar}>
                            <h5 className="item-text sidebar-collapse-option ml-1">
                                Direito
                            </h5>
                        </Link>
                        <Link className='nav-link' to="/profile" onClick={this.handleSidebar}>
                            <h5 className="item-text sidebar-collapse-option ml-1">
                                Empresarial
                            </h5>
                        </Link>
                        <Link className='nav-link' to="/profile" onClick={this.handleSidebar}>
                            <h5 className="item-text sidebar-collapse-option ml-1">
                                Contabilidade
                            </h5>
                        </Link>
                        <Link className='nav-link' to="/profile" onClick={this.handleSidebar}>
                            <h5 className="item-text sidebar-collapse-option ml-1">
                                Guia de estudos
                            </h5>
                        </Link>
                        <Link className='nav-link' to="/profile" onClick={this.handleSidebar}>
                            <h5 className="item-text sidebar-collapse-option ml-1">
                                Psicologia
                            </h5>
                        </Link> */}
          </Collapse>
          {this.props.authUser ? (
            <div>
              <Link
                className="nav-link"
                to={
                  this.props.isProfessional
                    ? "/profile-professional"
                    : "/profile"
                }
                onClick={this.handleSidebar}
              >
                <h4 className="item-text">{this.props.firstName}</h4>
              </Link>
              <Link className="nav-link" to="/" onClick={this.handleLogout}>
                <h4 className="item-text">Sair</h4>
              </Link>
            </div>
          ) : (
            <div>
              <Link
                className="nav-link"
                to="/signup"
                onClick={this.handleSidebar}
              >
                <h4 className="item-text">Cadastrar-se</h4>
              </Link>
              <Link
                className="nav-link"
                to="/login"
                onClick={this.handleSidebar}
              >
                <h4 className="item-text">Entrar</h4>
              </Link>
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    doLogout: userId => dispatch(UserProvider.signOut(userId)),
    doGetCategories: () => dispatch(CategoryProvider.getCategories()),
    doGetGroups: () => dispatch(CategoryProvider.getGroups()),
    doCheckLogin: () => dispatch(UserProvider.checkLogin())
  };
};
const mapStateToProps = state => {
  return {
    authUser: state.user.userInfo.token,
    userId: state.user.userInfo._id,
    firstName: state.user.userInfo.firstName,
    isProfessional: state.user.userInfo.isProfessional,
    categories: state.category.list
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
